import moment from 'moment';

export const isActive = user => {
  const {activeTill} = user.client;
  return activeTill && moment().diff(moment(activeTill)) < 0;
};

export const isLimited = user => {
  const {currentStart} = user.client;
  return currentStart && moment().diff(moment(currentStart)) < 0;
};
